/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Bridge_EmptyInputs */



/**
* | output |
* | --- |
* | "No active integration offers an External API yet." |
*
* @param {Api_Bridge_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_bridge_empty = /** @type {((inputs?: Api_Bridge_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Bridge_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch bietet keine aktive Integration eine externe API an.")
	return /** @type {LocalizedString} */ ("No active integration offers an External API yet.")
});